import { atom } from "jotai";

/**
 * Set this to true when you do not want page analytics to track the current page at this moment.
 * We need this in Tizen because when scrolling through the menu we do not want to register intermediate page changes.
 */
export const shouldBlockPageAnalyticsAtom = atom<boolean>(false);
